import { useState } from 'react';
import { Menu, X } from 'lucide-react';

export default function Header({ currentPage, setCurrentPage }) {
  const [menuOpen, setMenuOpen] = useState(false);

  const navItems = [
    { label: 'ホーム', page: 'home' },
    { label: 'ツール一覧', page: 'tools' },
    { label: '記事', page: 'articles' },
    { label: 'プロフィール', page: 'profile' },
  ];

  return (
    <header className="bg-amber-50 shadow-sm sticky top-0 z-50 no-print">
      <div className="max-w-5xl mx-auto px-4 py-4 flex items-center justify-between">
        <button
          onClick={() => setCurrentPage('home')}
          className="flex items-center gap-2 text-green-800 font-bold text-xl"
          style={{fontFamily: "'M PLUS Rounded 1c', sans-serif"}}
        >
          臨床ナースラボ
        </button>

        {/* デスクトップナビ */}
        <nav className="hidden md:flex items-center gap-6">
          {navItems.map((item) => (
            <button
              key={item.page}
              onClick={() => setCurrentPage(item.page)}
              className={`text-sm font-medium transition-colors ${
                currentPage === item.page
                  ? 'text-green-800 border-b-2 border-green-800 pb-0.5'
                  : 'text-gray-600 hover:text-green-800'
              }`}
            >
              {item.label}
            </button>
          ))}
        </nav>

        {/* モバイルメニューボタン */}
        <button
          className="md:hidden text-gray-600"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          {menuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* モバイルメニュー */}
      {menuOpen && (
        <div className="md:hidden bg-amber-50 border-t border-amber-100 px-4 py-3 flex flex-col gap-3">
          {navItems.map((item) => (
            <button
              key={item.page}
              onClick={() => { setCurrentPage(item.page); setMenuOpen(false); }}
              className={`text-left text-sm font-medium py-2 ${
                currentPage === item.page ? 'text-green-800' : 'text-gray-600'
              }`}
            >
              {item.label}
            </button>
          ))}
        </div>
      )}
    </header>
  );
}
